import React from 'react';
import { Section } from './ui/Section';
export function PainPoints() {
  const cards = [{
    title: 'Panes que no se parecen al pan',
    desc: 'Textura seca, quebradiza o poco apetecible.',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/3f49c437-c09a-4026-82aa-ac830f3f0d05.jpg'
  }, {
    title: 'Masas que no responden igual',
    desc: 'Recetas que se rompen, no crecen o pierden estructura.',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/d73f1051-9960-42ca-8492-0ba48b6ffd16.jpg'
  }, {
    title: 'Comer "diferente" todo el tiempo',
    desc: 'Tener que adaptar tus comidas mientras los demás comen lo de siempre.',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/4063585a-4a69-45a4-974f-57a64208cde0.jpg'
  }];
  return <Section variant="alt" data-id="element-124" data-mp="3idungip6pxg6">
      <h2 className="font-display text-[26px] md:text-4xl font-bold text-center mb-3 text-brand-title max-w-2xl mx-auto leading-tight" data-id="element-125" data-mp="3iemjfump1x6z">
        Comer sin gluten no debería significar comer sin disfrutar.
      </h2>
      <p className="text-center text-brand-text font-body mb-10 max-w-xl mx-auto text-sm md:text-base leading-relaxed" data-id="element-126" data-mp="1yzdm4jp9m7lh">
        Cuando eliminas el gluten, muchas veces también desaparecen las
        texturas, recetas y comidas que formaban parte de tu día a día.
      </p>

      <div className="grid md:grid-cols-3 gap-5 max-w-4xl mx-auto" data-id="element-127" data-mp="23r56gchtvh36">
        {cards.map((card, i) => <div key={i} className="bg-white border border-brand-border rounded-2xl overflow-hidden shadow-card" data-id="element-128" data-mp="1g1awc2ow86mm" data-mpi={i}>
            <div className="aspect-[4/3] overflow-hidden" data-id="element-129" data-mp="1b3rhp1oa9ru5">
              <img src={card.img} alt={card.title} className="w-full h-full object-cover" loading="lazy" data-id="element-130" data-mp="1p2hf6if0ltj1" />
            </div>
            <div className="p-5" data-id="element-131" data-mp="1k2wbjuowgwzz">
              <h3 className="font-heading font-bold text-brand-title mb-1.5 text-base" data-id="element-132" data-mp="1k1urx1ttj26n">
                {card.title}
              </h3>
              <p className="font-body text-brand-textMuted text-sm leading-snug" data-id="element-133" data-mp="2vil2ex59yg62">
                {card.desc}
              </p>
            </div>
          </div>)}
      </div>
    </Section>;
}